import * as appTypes from 'types/app';
import { DiscountType } from '@kouto/cart-prices';

export const DELETE_CREDIT_CODE = '@credit-codes/delete-credit-code';

export const VALIDATE_CREDIT_CODE_REQUEST =
  '@credit-codes/validate-credit-code-request';
export const VALIDATE_CREDIT_CODE_SUCCESS =
  '@credit-codes/validate-credit-code-success';
export const VALIDATE_CREDIT_CODE_FAILURE =
  '@credit-codes/validate-credit-code-failure';
export const RESET_CREDIT_CODE_STATUS =
  '@credit-codes/reset-credit-code-status';
export const DELETE_ALL_CREDIT_CODES = '@credit-codes/delete-all-credit-codes';
export const RESTORE_PERSISTED_CREDIT_CODES =
  '@credit-codes/restore-persisted-credit-codes';

export type CreditCode = {
  code: string;
  discountType: DiscountType;
  id: string;
  type: string;
  value: number;
};
export interface CreditCodes {
  creditCodes: CreditCode[];
  responseStatus: number;
  error: string;
  validationMessages: string;
  validateCreditCodeStatus: (typeof appTypes)[keyof typeof appTypes];
}
